import React, { Component } from "react"
import helper from "../../../../utils/helper"

import CardDefault from "./cardDefault"
import ChartPlanos from "./chartPlanos"
import CardPlanos from "./cardPlanos"

class index extends Component {
    render() {
        const { data, faturamento_por } = this.props

        const periodoDeFaturamento = {
            hora: `${data.quantidade_de_hora_faturados} hora(s)`,
            dia: `${data.quantidade_de_dia_faturados} dia(s)`,
            mes: `${data.quantidade_de_mes_faturados} ${data.quantidade_de_mes_faturados <= 1 ? "mês" : "meses"}`,
            ano: `${data.quantidade_de_ano_faturados} ano(s)`
        }

        const periodoDeFaturamentoCardPlano= {
            hora: "por hora",
            dia: "diario",
            mes: "mensal",
            ano: "anual"
        }

        return (
            <>
                <div className="row" style={{padding: "0px 15px", gap: "10px", flexWrap: "nowrap"}}>
                    <CardDefault 
                        label={"Faturamento Total"} 
                        value={helper.formatMoney(data.total_de_faturamento)} 
                        subText={`Período de ${periodoDeFaturamento[faturamento_por.value]}`} 
                        icon="fa fa-dollar-sign fa-30px" 
                        colorBall="#2ad16724" 
                        colorIcon="#2ad167"
                    />

                    <CardDefault 
                        label={`Faturamento por ${faturamento_por.label}`} 
                        value={helper.formatMoney(data[`total_de_faturamento_por_${faturamento_por.value}`])} 
                        subText={`Período de 1 ${faturamento_por.label.toLowerCase()}`} 
                        icon="fa fa-dollar-sign fa-30px" 
                        colorBall="#2ad16724" 
                        colorIcon="#2ad167"
                    />
                    
                    <CardDefault 
                        label={"Média por Cliente"} 
                        value={helper.formatMoney(data.media_de_faturamento_por_cliente)} 
                        subText={`Total de ${data.quantidade_de_clientes_selecionados} cliente(s)`} 
                        icon="fa fa-users fa-30px" 
                        colorBall="#dbeafe" 
                        colorIcon="#2563eb"
                    />

                    <CardDefault 
                        label={"Quantidade de Planos"} 
                        value={data.quantidade_de_planos} 
                        subText={`Distribuídos entre ${data.quantidade_de_clientes} cliente(s)`} 
                        icon="fa fa-file-invoice-dollar fa-30px" 
                        colorBall="#f3e8ff" 
                        colorIcon="#9333ea"
                    />
                </div>

                <div className="container-default w-100 mt-3">
                    <span style={{fontSize: "20px", fontWeight: "bold", color: "var(--fonte_titulo_abas)"}}>Distribuição de Receita por Plano</span>
                    <ChartPlanos data={data.relatorio_de_cada_plano}/>
                </div>

                <div className="mt-3">
                    <span style={{fontSize: "20px", fontWeight: "bold", color: "var(--fonte_titulo_abas)"}}>Detalhamento por Plano</span>
                    <div className="row mt-1 pl-3 pr-3" style={{ gap: "10px" }}>
                        {
                            data.relatorio_de_cada_plano.map((item, index) => {
                                return  <CardPlanos 
                                            data={item} 
                                            periodoDeFaturamentoString={periodoDeFaturamentoCardPlano[faturamento_por.value]} 
                                            periodoDeFaturamento={faturamento_por.value}
                                        />
                            })
                        }
                    </div>
                </div>
            </>
        )
    }
}

export default index